export default [{
  path: "/sign-in",
  name: "sign-in",
  component: () => import(/* webpackChunkName: "auth-signin" */ "@/pages/auth/SigninPage.vue"),
  meta: {
    layout: "auth",
    public: true
  }
}, {
  path: "/sign-up",
  name: "sign-up",
  component: () => import(/* webpackChunkName: "auth-signup" */ "@/pages/auth/SignupPage.vue"),
  meta: {
    layout: "auth",
    public: true
  }
}, {
  path: "/verify-email",
  name: "verify-email",
  component: () => import(/* webpackChunkName: "auth-verify-email" */ "@/pages/auth/VerifyEmailPage.vue"),
  meta: {
    layout: "auth"
  }
}, {
  path: "/forgot-password",
  name: "forgot-password",
  component: () => import(/* webpackChunkName: "auth-forgot" */ "@/pages/auth/ForgotPage.vue"),
  meta: {
    layout: "auth"
  }
}, {
  path: "/reset-password",
  name: "reset-password",
  component: () => import(/* webpackChunkName: "auth-reset" */ "@/pages/auth/ResetPage.vue"),
  meta: {
    layout: "auth",
    public: true
  }
}, {
  path: "/error/not-found",
  name: "error-not-found",
  component: () => import(/* webpackChunkName: "error-not-found" */ "@/pages/error/NotFoundPage.vue"),
  meta: {
    layout: "error",
    public: true
  }
}, {
  path: "/error/unexpected",
  name: "error-unexpected",
  component: () => import(/* webpackChunkName: "error-unexpected" */ "@/pages/error/UnexpectedPage.vue"),
  meta: {
    layout: "error"
  }
}, {
  path: "/utility/maintenance",
  name: "utility-maintenance",
  component: () => import(/* webpackChunkName: "utility-maintenance" */ "@/pages/utility/MaintenancePage.vue"),
  meta: {
    layout: "auth",
    public: true
  }
}, {
  path: "/utility/coming-soon",
  name: "utility-soon",
  component: () => import(/* webpackChunkName: "utility-soon" */ "@/pages/utility/SoonPage.vue"),
  meta: {
    layout: "auth"
  }
}, {
  path: "/utility/help",
  name: "utility-help",
  component: () => import(/* webpackChunkName: "utility-help" */ "@/pages/utility/HelpPage.vue")
}];
